import { Link } from "react-router-dom";
import images from "../../assets/images/assets";
import Button1 from "../SmallComponents/Button1";

const OurStorySection = () => {
  return (
    <div className="bg-transparent w-full p-4 text-prime-red ">
      <div className="bg-transparent p-4 col items-center gap-6">
        {/* Header */}

        <h2 className=" playfair-display  heading-1 relative text-prime-red">
          <img
            src={images.star1}
            alt="decorative"
            className="w-4 absolute left-40 md:left-62 lg:left-72 -top-3 md:-top-5"
          />
          Every card tells a story.
        </h2>

        {/* Story */}
        <p className="black-text montserrat text-center indent-2 md:w-3/4 md:mb-2 lg:w-[50%] lg:text-lg text-prime-red">
          At <strong>it&#39;s all about cards</strong>, every invitation tells a
          story. From the thoughtfully chosen designs that reflect your unique
          style to the carefully selected materials that showcase our dedication
          to quality, each card we create is a tribute to the special moments
          and memories you&#39;re about to make.
        </p>

        {/* Read More */}
        <Link to="/story">
          <Button1 title=" Read our story" />
        </Link>
      </div>
    </div>
  );
};

export default OurStorySection;
